var _path, _path2, _g, _g2, _g3, _g4, _g5, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3626 4.19411C14.8986 4.43988 13.615 4.06593 12.5119 3.07224C11.4091 2.07856 10.4268 2.18637 9.56544 3.39541C8.70378 4.60445 7.53199 5.24781 6.04926 5.32493C4.5668 5.40233 3.94819 6.17305 4.19422 7.6371C4.43999 9.10114 4.06604 10.3849 3.0724 11.488C2.07876 12.5908 2.18629 13.5731 3.39556 14.4345C4.60455 15.296 5.24788 16.4681 5.32528 17.9506C5.4024 19.4334 6.17309 20.0517 7.63735 19.8057C9.10134 19.5599 10.385 19.9339 11.4881 20.9276C12.5909 21.9212 13.5732 21.8134 14.4348 20.6044C15.2962 19.3954 16.4683 18.752 17.9507 18.6746C19.4335 18.5975 20.0518 17.8268 19.8058 16.3627C19.56 14.8984 19.9339 13.6149 20.9276 12.5118C21.9212 11.409 21.8137 10.4267 20.6044 9.56526C19.3954 8.70383 18.7521 7.53173 18.6747 6.04922C18.5976 4.56643 17.8269 3.94806 16.3626 4.19411Z",
    fill: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3626 4.19411C14.8986 4.43988 13.615 4.06593 12.5119 3.07224C11.4091 2.07856 10.4268 2.18637 9.56544 3.39541C8.70378 4.60445 7.53199 5.24781 6.04926 5.32493C4.5668 5.40233 3.94819 6.17305 4.19422 7.6371C4.43999 9.10114 4.06604 10.3849 3.0724 11.488C2.07876 12.5908 2.18629 13.5731 3.39556 14.4345C4.60455 15.296 5.24788 16.4681 5.32528 17.9506C5.4024 19.4334 6.17309 20.0517 7.63735 19.8057C9.10134 19.5599 10.385 19.9339 11.4881 20.9276C12.5909 21.9212 13.5732 21.8134 14.4348 20.6044C15.2962 19.3954 16.4683 18.752 17.9507 18.6746C19.4335 18.5975 20.0518 17.8268 19.8058 16.3627C19.56 14.8984 19.9339 13.6149 20.9276 12.5118C21.9212 11.409 21.8137 10.4267 20.6044 9.56526C19.3954 8.70383 18.7521 7.53173 18.6747 6.04922C18.5976 4.56643 17.8269 3.94806 16.3626 4.19411Z",
    fill: "url(#paint0_linear_5069_41440)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_5069_41440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 5.27979C8.28907 5.27979 5.28046 8.23479 5.28046 11.8798C5.28046 15.5248 8.28907 18.4798 12.0002 18.4798C15.7113 18.4798 18.7199 15.5248 18.7199 11.8798C18.7199 8.23479 15.7113 5.27979 12.0002 5.27979Z",
    fill: "url(#paint1_linear_5069_41440)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5069_41440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.15567 14.3996L7.92143 10.6594L10.1842 11.4074L12.0356 8.63965L13.8868 11.4074L16.1496 10.6594L14.9153 14.3996H9.15567Z",
    fill: "url(#paint2_linear_5069_41440)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5069_41440)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.0332,
    cy: 8.11343,
    r: 0.33218,
    fill: "url(#paint3_linear_5069_41440)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_5069_41440)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.4844,
    cy: 10.3058,
    r: 0.33218,
    fill: "url(#paint4_linear_5069_41440)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_5069_41440)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.58198,
    cy: 10.3058,
    r: 0.33218,
    fill: "url(#paint5_linear_5069_41440)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26677 7.40625L8.37196 7.72371L8.6918 7.82811L8.37196 7.93252L8.26677 8.24997L8.16158 7.93252L7.84174 7.82811L8.16158 7.72371L8.26677 7.40625Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99174 6L7.23718 6.74073L7.98348 6.98434L7.23718 7.22796L6.99174 7.96869L6.7463 7.22796L6 6.98434L6.7463 6.74073L6.99174 6Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_5069_41440",
    x: 5.28046,
    y: 5.27979,
    width: 13.6056,
    height: 13.4216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.16609,
    dy: 0.221453
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.138408
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.291667 0 0 0 0 0.126617 0 0 0 0 0.0157986 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5069_41440"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5069_41440",
    x: 7.53389,
    y: 8.47356,
    width: 9.00321,
    height: 6.53485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.221453
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.193772
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.625 0 0 0 0 0.403263 0 0 0 0 0.122396 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5069_41440"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5069_41440",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5069_41440",
    x: 11.5903,
    y: 7.78125,
    width: 0.885821,
    height: 0.886004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.110727
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0553633
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.625 0 0 0 0 0.403263 0 0 0 0 0.122396 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5069_41440"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5069_41440",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5069_41440",
    x: 16.0415,
    y: 9.97363,
    width: 0.885806,
    height: 0.886004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.110727
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0553633
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.625 0 0 0 0 0.403263 0 0 0 0 0.122396 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5069_41440"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5069_41440",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_5069_41440",
    x: 7.13907,
    y: 9.97363,
    width: 0.885806,
    height: 0.886004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.110727
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0553633
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.625 0 0 0 0 0.403263 0 0 0 0 0.122396 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5069_41440"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5069_41440",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5069_41440",
    x1: 12,
    y1: 2.78575,
    x2: 12,
    y2: 21.2141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4DC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490269,
    stopColor: "#F8DB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A409"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5069_41440",
    x1: 12.0002,
    y1: 5.27979,
    x2: 12.0002,
    y2: 18.4798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9962F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838966,
    stopColor: "#BD722A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5069_41440",
    x1: 12.0355,
    y1: 8.7554,
    x2: 12.0355,
    y2: 14.2839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377193,
    stopColor: "#F6CB53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C30A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5069_41440",
    x1: 12.0332,
    y1: 7.78125,
    x2: 12.0332,
    y2: 8.44561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59C23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5069_41440",
    x1: 16.4844,
    y1: 9.97363,
    x2: 16.4844,
    y2: 10.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59C23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5069_41440",
    x1: 7.58198,
    y1: 9.97363,
    x2: 7.58198,
    y2: 10.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59C23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolden);
export default __webpack_public_path__ + "static/media/golden.e63f31696efb6865013b55781ae41aa8.svg";
export { ForwardRef as ReactComponent };